const modalsConfig = {
  newCvvCodeModal: {
    resolve: () => import('../modules/new-cvv-code-modal')
  }
};

export {
  modalsConfig
};
